// Generic count keys whose meaning is ambiguous when surfaced to the LLM (TL-1 migration from aiUtils.js).
// Backends use these for assorted aggregation dimensions (class slots, membership types, page totals)
// that may differ from items.length. Exposing them invites "총 N건" hallucination
// where users see row count R but the LLM cites unrelated value V.
export const AMBIGUOUS_COUNT_KEYS = new Set(['totalCount', 'count', 'total', 'cnt', 'totalCnt', 'totalCnts']);
export function isAmbiguousCountKey(k) { return AMBIGUOUS_COUNT_KEYS.has(k); }
